import { ITabContainer } from '../types';

export function getIframe() {
  return window.frameElement as HTMLIFrameElement;
}

export function getTabContainer() {
  const tabsController = getIframe()?.getReactTabsController?.();
  if (tabsController) return tabsController;

  const windowTop = window.top;
  const isIniFrame = windowTop?.document != null;
  let result: HTMLElement | typeof window.tabsController | null =
    document.getElementById('tabContainer');
  if (result === null && isIniFrame)
    result =
      windowTop.document.getElementById('tabContainer') ??
      windowTop.tabsController;

  return result as unknown as ITabContainer;
}
